import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const ArrowLeft = ({ color = '#B5BCBD', size = 20, ...props }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    viewBox="0 0 20 24"
    {...props}
  >
    <g strokeWidth="2" fill={color}>
      <polygon points="19.7 11 7.5 11 13.1 5.4 11.7 4 3.7 12 11.7 20 13.1 18.6 7.5 13 19.7 13" />
    </g>
  </svg>
);

ArrowLeft.propTypes = propTypes;

export default ArrowLeft;
